interface BaseItem {
  id: string;
}

export const getSortedEntries = <T extends BaseItem>(
  layout: string[] = [],
  entries: T[],
  options: {
    /**
     * If `true` unknown items (unknown to layout) will be moved to the bottom of the list retaining their original order.
     */
    moveUnknownToTheBottom?: boolean;
  } = {},
): T[] => {
  const result = Array.from(entries ? [...entries] : []);
  return result.sort((a, b) => {
    const aIndex = layout.indexOf(a.id);
    const bIndex = layout.indexOf(b.id);

    if (options.moveUnknownToTheBottom) {
      if (aIndex === -1) {
        return 1;
      }

      if (bIndex === -1) {
        return -1;
      }
    }

    return aIndex - bIndex;
  });
};
